var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.updateChartFlag
    ? _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.chartData.loading,
              expression: "chartData.loading",
            },
          ],
          ref: "middleLayerRef",
          staticClass: "jzliu-bi-engine-middle-layer cdsp_dashboard",
        },
        [
          _vm.showActionMenu && !_vm.isDown
            ? _c(
                "div",
                { staticClass: "jzliu-bi-engine-middle-layer-drag-handle" },
                [
                  _c(
                    "el-dropdown",
                    { on: { command: _vm.handleCommand } },
                    [
                      _c("span", { staticClass: "el-dropdown-link" }, [
                        _c("i", { staticClass: "el-icon-more" }),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-dropdown-menu",
                        { attrs: { slot: "dropdown" }, slot: "dropdown" },
                        [
                          _vm.showChartPreview
                            ? _c(
                                "el-dropdown-item",
                                { attrs: { command: "dataChartPreview" } },
                                [_vm._v("预览图表数据")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "el-dropdown-item",
                            { attrs: { command: "dwsPreview" } },
                            [_vm._v("预览明细数据")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-dropdown-item",
                            { attrs: { command: "exportImg" } },
                            [_vm._v("导出")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.showTitle && _vm.isHasDrill(_vm.chartData)
            ? _c(
                "div",
                { staticClass: "jzliu-bi-engine-middle-layer-drill-handle" },
                [
                  _c("img", {
                    attrs: {
                      src: require("../../assets/img/drill2.png"),
                      alt: "drill",
                      width: "13px",
                      height: "13px",
                    },
                  }),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showTitle
            ? _c(
                "div",
                { staticClass: "chart-header" },
                [
                  _vm.chartData.styleConfig.commongConfig.showTitle
                    ? _c("span", { staticClass: "jzliu-bi-engine-title" }, [
                        _vm._v(
                          "\n      " + _vm._s(_vm.chartData.name) + "\n    "
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.chartData.styleConfig.commongConfig.showRemark
                    ? [
                        _vm.chartData.styleConfig.commongConfig
                          .remarkPosition === _vm.remarkPositionMap.title
                          ? _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  content:
                                    _vm.chartData.styleConfig.commongConfig
                                      .remark,
                                  placement: "right",
                                },
                              },
                              [_c("i", { staticClass: "el-icon-question" })]
                            )
                          : _vm._e(),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isHasDrill(_vm.chartData) && !_vm.isDown
                    ? _c("el-tooltip", { attrs: { placement: "right" } }, [
                        _c("img", {
                          staticStyle: { position: "relative", top: "2px" },
                          attrs: {
                            src: require("../../assets/img/drill2.png"),
                            alt: "drill",
                            width: "13px",
                            height: "13px",
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { attrs: { slot: "content" }, slot: "content" },
                          [
                            _c("div", [_vm._v("点击图表可下钻，钻取层级为：")]),
                            _vm._v(" "),
                            _c(
                              "el-breadcrumb",
                              {
                                staticStyle: { "margin-top": "10px" },
                                attrs: {
                                  "separator-class": "el-icon-arrow-right",
                                },
                              },
                              _vm._l(
                                _vm.drillFieldsBreadcrumb,
                                function (item, index) {
                                  return _c("el-breadcrumb-item", [
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          color: "#fff",
                                          "font-size": "12px",
                                        },
                                      },
                                      [_vm._v(_vm._s(item))]
                                    ),
                                  ])
                                }
                              ),
                              1
                            ),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showRemark
            ? _c("div", [
                _c("span", { staticClass: "remark" }, [
                  _vm._v(
                    _vm._s(_vm.chartData.styleConfig.commongConfig.remark)
                  ),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.isEmptyData
            ? _c(
                "div",
                {
                  staticClass: "chart-content",
                  style: {
                    height: _vm.showTitle
                      ? _vm.isShowDrill
                        ? _vm.showRemark
                          ? "calc(100% - 70px)"
                          : "calc(100% - 50px)"
                        : _vm.showRemark
                        ? "calc(100% - 50px)"
                        : "calc(100% - 30px)"
                      : _vm.isShowDrill
                      ? _vm.showRemark
                        ? "calc(100% - 40px)"
                        : "calc(100% - 20px)"
                      : _vm.showRemark
                      ? "calc(100% - 20px)"
                      : "calc(100%)",
                  },
                },
                [
                  _c(_vm.computedTpl, {
                    ref: "computedTplRef",
                    tag: "component",
                    attrs: {
                      chartConfigHandler: _vm.chartConfigHandler,
                      isShowDrill: _vm.isShowDrill,
                      chartData: _vm.chartData,
                    },
                    on: {
                      "table-page-change": _vm.handleTablePageChange,
                      "drill-item-click": _vm.handleDrillItemClick,
                    },
                  }),
                  _vm._v(" "),
                  _vm.isShowDrill
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "jzliu-bi-engine-middle-layer-drill-handle-content",
                          staticStyle: { height: "20px" },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "jzliu-bi-engine-middle-layer-drill-handle-content-item",
                            },
                            [
                              _c(
                                "el-breadcrumb",
                                {
                                  attrs: {
                                    "separator-class": "el-icon-arrow-right",
                                  },
                                },
                                _vm._l(
                                  _vm.chartData.drillFields,
                                  function (item, index) {
                                    return _c(
                                      "el-breadcrumb-item",
                                      { key: item.value },
                                      [
                                        _c(
                                          "span",
                                          {
                                            style: {
                                              cursor:
                                                index <=
                                                _vm.chartData.drillFields
                                                  .length -
                                                  1
                                                  ? "pointer"
                                                  : "default",
                                            },
                                            attrs: { title: item.label },
                                            on: {
                                              click: function ($event) {
                                                return _vm.onSpliceDrillField(
                                                  index
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v(_vm._s(item.label))]
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              )
            : _c(
                "div",
                { staticClass: "jzliu-bi-engine-empty-data-container" },
                [
                  _c("img", {
                    attrs: {
                      src: require("../../assets/img/empty2.png"),
                      alt: "empty",
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "jzliu-bi-engine-empty-text" }, [
                    _vm._v(
                      _vm._s(_vm.chartData.isError ? "数据出错" : "暂无数据")
                    ),
                  ]),
                ]
              ),
          _vm._v(" "),
          _c("data-chart-preview", {
            ref: "dataChartPreviewRef",
            attrs: {
              chartData: _vm.chartData,
              direction: _vm.chartDirection,
              mode: _vm.chartPreviewMode,
            },
            on: { "sort-change": _vm.handleSortChange },
          }),
          _vm._v(" "),
          _c("dws-preview", {
            ref: "dwsPreviewRef",
            attrs: { chartData: _vm.chartData, mode: _vm.previewMode },
            on: { "sort-change": _vm.handleSortChange },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }